import { WLTPRangeValue } from '../../../services/victor/trim-layer-details-response';

export function findVehicleEmissionData(wltp: WLTPRangeValue[], energyType: string) {
	const NEDC_PHASE = 'COMBINED';
	return wltp.filter(obj => obj.energyManagementType === energyType && obj.phase === NEDC_PHASE);
}

export function createEfficiencyValueString(data: { min: string | number; max: string | number }, unit = '') {
	return data.min === data.max ? `${data.max} ${unit}`.trim() : `${data.max} - ${data.min} ${unit}`.trim();
}
